export const themes = {
  default: {
    thRoot: 'font-base font-bold relative text-center',
    thDayPicker: {
      container: 'relative sm:rounded-12', // The container element
      wrapper: '', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: 'flex items-center justify-between pb-10', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: 'flex -m-10', // Container of the months table
      month: 'flex-1 p-10', // The month's main table
      caption: 'font-bold mb-20 text-center text-16 text-black capitalize', // The caption element, containing the current month's name and year
      weekdays: '', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday: 'flex-1 text-14 text-mediumGrey uppercase', // Cell displaying the weekday name
      body: 'body border-l border-b border-grey', // Table's body with the weeks
      week: 'flex', // Table's row for each week
      day: 'font-bold cursor-pointer flex-1 flex flex-col items-center justify-center md:h-100 h-52 p-5 text-14 text-center duration-250 ease-in transition-all border-t border-r border-grey', // The single day cell
      footer: 'mt-10', // The calendar footer (only with todayButton prop)
      todayButton: 'text-black hocus:text-black-active text-12', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline', // Added to the day's cell for the current day
      selected: 'bg-black/30 opacity-100 !text-white Datepicker-selected', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'font-normal cursor-default pointer-events-none line-through', // Added to the day's cell specified in the "disabledDays" prop
      outside: '', // Added to the day's cell outside the current month
    },
    thDayStart: 'thDayStart !bg-black !bg-black-active !text-white',
    thDayEnd: 'thDayEnd !bg-black-active !text-white',
    thDayMiddle: 'thDayMiddle !bg-black !text-white',
  },
  compact: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:rounded-12', // The container element
      wrapper: '', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: 'flex items-center justify-between pb-10', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: 'flex flex-col lg:flex-row px-10 lg:px-0', // Container of the months table
      month: 'flex-1 p-10', // The month's main table
      caption: 'capitalize font-bold mb-20 text-16 text-black text-center', // The caption element, containing the current month's name and year
      weekdays: 'mb-20', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday: 'flex-1 font-semibold text-16 text-black uppercase', // Cell displaying the weekday name
      body: 'body', // Table's body with the weeks
      week: 'flex mb-1 rounded-4 overflow-hidden', // Table's row for each week
      day: 'cursor-pointer flex-1 flex flex-col items-center justify-center h-48 p-5 text-14 text-center duration-250 ease-in transition-all', // The single day cell
      footer: 'mt-10', // The calendar footer (only with todayButton prop)
      todayButton: 'text-black hocus:text-black-active text-12', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'today', // Added to the day's cell for the current day
      selected: 'bg-black reset-decoration !text-white Datepicker-selected', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none line-through text-lightGrey', // Added to the day's cell specified in the "disabledDays" prop
      outside: '!bg-white', // Added to the day's cell outside the current month
    },
    thDayStart: 'reset-decoration rounded-4 rounded-e-0 !text-white',
    thDayEnd: 'reset-decoration rounded-4 rounded-s-0 !text-white',
    thDayMiddle: '!bg-black reset-decoration !text-white',
    thHeader: 'mb-40',
  },
  defaultFormikInput: {
    thDayPicker: {
      container: 'overflow-hidden relative', // The container element
      wrapper: 'outline-none text-center', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: '', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: '', // Container of the months table
      month: '', // The month's main table
      caption: 'font-bold mb-20 text-center text-16 text-black capitalize', // The caption element, containing the current month's name and year
      weekdays: '', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday:
        'font-bold flex-1 flex-1 flex flex-col items-center justify-center h-36 text-14 text-mediumGrey uppercase', // Cell displaying the weekday name
      body: 'body', // Table's body with the weeks
      week: 'flex', // Table's row for each week
      day: 'font-bold hocus:bg-black cursor-pointer flex-1 flex flex-col group items-center justify-center h-36 outline-none p-5 text-14 text-center hocus:text-white duration-250 ease-in transition-all', // The single day cell

      footer: 'mt-10', // The calendar footer (only with todayButton prop)
      todayButton: 'text-black hocus:text-black-active text-12', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline', // Added to the day's cell for the current day
      selected: '', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'font-normal cursor-default pointer-events-none text-mediumGrey line-through', // Added to the day's cell specified in the "disabledDays" prop
      outside: '', // Added to the day's cell outside the current month
    },
    thDayEnd: '!bg-black rounded-e-12 text-white',
    thDayHovered: 'rounded-e-12',
    thDaysHovered: 'bg-black/40 text-white',
    thDaysSelected: '!bg-black text-white',
    thDayStart: '!bg-black rounded-s-12 text-white',
  },
};
